// extracted by mini-css-extract-plugin
module.exports = {"card":"FAQAccordionToggle_card__6To5l","accordian-toggle-arrow":"FAQAccordionToggle_accordian-toggle-arrow__875zH","active":"FAQAccordionToggle_active__ApBoQ"};